import { CONSENT_ADVERTISING, META_STANDARD_EVENTS, eventName as resolveEventName } from "../events";
import { injectScript } from "./script";

/**
 * Meta Pixel (snippet oficial fbevents.js). Só com consentimento de advertising.
 */
export default {
    name: "meta",

    isAllowed(config, allowed) {
        return !!(config && config.pixel_id) && allowed(CONSENT_ADVERTISING);
    },

    init(config) {
        if (!window.fbq) {
            const fbq = function () {
                fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
            };
            if (!window._fbq) {
                window._fbq = fbq;
            }
            fbq.push = fbq;
            fbq.loaded = true;
            fbq.version = "2.0";
            fbq.queue = [];
            window.fbq = fbq;

            injectScript("https://connect.facebook.net/en_US/fbevents.js");
        }

        window.fbq("init", config.pixel_id);
        window.fbq("track", "PageView");
    },

    send(eventName, payload, config) {
        const nativeName = resolveEventName("meta", config, eventName);
        if (!nativeName || typeof window.fbq !== "function") {
            return;
        }

        // Evento personalizado pelo cliente fora do padrão da Meta exige trackSingleCustom
        const method = META_STANDARD_EVENTS.indexOf(nativeName) >= 0 ? "trackSingle" : "trackSingleCustom";

        window.fbq(
            method,
            config.pixel_id,
            nativeName,
            {
                content_type: "job",
                content_ids: payload.job_id ? [String(payload.job_id)] : undefined,
                content_name: payload.job_title,
                portal_id: payload.portal_id,
                source: payload.source,
                medium: payload.medium,
                campaign: payload.campaign,
            },
            { eventID: payload.event_id }
        );
    },
};
